// Per-tab dashboard provider (ANS-1106): on an environment whose config sets
// `dashboardsSwitch`, `?dashboards=thoughtspot` or `?dashboards=jitto` picks where
// this browser tab's dashboards come from, so two tabs show ThoughtSpot and Jitto
// side by side on one origin (no new host for ThoughtSpot, Okta or CORS to admit).
// The pick is kept in sessionStorage: it survives the Okta sign-in redirect, which
// drops the query string, and it never leaks into another tab.
// Every other environment ignores the parameter.
export const SWITCH_PARAM = 'dashboards';
export const SWITCH_KEY = 'tca.dashboards';
const PROVIDERS = ['thoughtspot', 'jitto'];

function read(storage) {
  try {
    return storage ? storage.getItem(SWITCH_KEY) : null;
  } catch (ignored) {
    return null;
  }
}

function write(storage, value) {
  try {
    if (storage) storage.setItem(SWITCH_KEY, value);
  } catch (ignored) {
    // Blocked storage: the pick lasts until the next page load only.
  }
}

function forget(storage) {
  try {
    if (storage) storage.removeItem(SWITCH_KEY);
  } catch (ignored) {
    // Blocked storage: nothing was kept.
  }
}

// The provider this tab asked for, or null. A known value wins and is kept; an
// unknown one forgets the kept pick (the default again); none reads the kept pick.
export function pickedProvider(search, storage) {
  const params = new URLSearchParams(search || '');
  if (params.has(SWITCH_PARAM)) {
    const asked = (params.get(SWITCH_PARAM) || '').toLowerCase();
    if (PROVIDERS.includes(asked)) {
      write(storage, asked);
      return asked;
    }
    forget(storage);
    return null;
  }
  const kept = read(storage);
  return PROVIDERS.includes(kept) ? kept : null;
}

// The config this tab runs. ThoughtSpot: the Jitto flag off, the dashboards
// `thoughtSpotDashboards` (when set) instead of the Jitto routes, and the Jitto-only
// asset classes (`jittoOnlyAssetClasses`, FX Swap) gone, so the menu hides them.
// Jitto: the flag on. No pick, or no `dashboardsSwitch`: the config unchanged.
export function applyDashboardsSwitch(config, search, storage) {
  if (!config || !config.dashboardsSwitch) return config;
  const provider = pickedProvider(search, storage);
  if (provider === 'jitto') return { ...config, jittoEmbedActiveFlag: true };
  if (provider !== 'thoughtspot') return config;
  const dashboards = { ...(config.thoughtSpotDashboards || config.dashboards) };
  for (const assetClass of config.jittoOnlyAssetClasses || []) delete dashboards[assetClass];
  return { ...config, jittoEmbedActiveFlag: false, dashboards };
}
